import { AvantArteLogo, Button } from '@design-system';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';

import { SimpleLayout } from '../../../components/Layout/SimpleLayout';
import { imageLoader } from '../../../helpers/images';

export const Page404 = () => {
  const { t } = useTranslation('private');

  return (
    <SimpleLayout canonicalUrl="" theme="dark" title={t('notFound.title')}>
      <div
        className="duration-400 h-full w-full bg-cover transition-all ease-in-out"
        style={{
          backgroundImage: `url('${imageLoader({
            src: 'https://images.avantarte.org/media/2nn9zcdF1EZ5Ypw2jIyPYoibbeM',
            width: 1200,
          })}')`,
        }}
      >
        <div className="flex h-full min-h-screen flex-col bg-neutral-6/60 backdrop-blur-[30px]">
          <div className="flex h-14 items-center justify-center border-b border-white/20 md:h-18">
            <AvantArteLogo
              className="text-white max-md:hidden"
              variant="wordmark"
            />
            <AvantArteLogo className="text-white md:hidden" variant="icon" />
          </div>
          <div className="mx-auto flex max-w-md flex-1 flex-col items-center justify-center gap-6 px-6 py-12">
            <h1 className="w-full text-balance text-center text-md font-bold text-white sm:text-lg">
              {t('notFound.title')}
            </h1>
            <p className="text-center text-white">
              <Trans
                components={{
                  Link: (
                    <Link
                      className="hyperlink"
                      href="mailto:collecting@avantarte.com"
                    />
                  ),
                }}
                i18nKey="notFound.description"
                t={t}
              />
            </p>
            <Button as="a" fullWidth href="/" label={t('notFound.cta')} />
          </div>
        </div>
      </div>
    </SimpleLayout>
  );
};
